import React, { Component } from "react";
import FileSaver from "file-saver";
import Delete from '../../../Assets/img/svg/delete.svg';
import del from "../../../Assets/img/svg/Del.svg";
import downloadIcon from '../../../Assets/img/svg/DownloadIcon.svg';
import downloadiconblue from '../../../Assets/img/svg/Downloadiconblue.svg';
import $ from 'jquery';
import withRouter from "../../custom/withRouter";
import { connect } from "react-redux";
import styles from "../../../Assets/jss/customStyle";
import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import moment from "moment"
import axios from "axios";
import API from "../../../helpers/endpointService";
import { CssTextField } from "../../custom/textField"
import View from '../../../Assets/img/svg/view.svg';
import Viewblue from '../../../Assets/img/svg/viewblue.svg';
import upload from '../../../Assets/img/svg/upload.svg';
import swal from "sweetalert";
import { successAlert, warningAlert } from "../../custom/alert";

class shipImage extends Component {
    constructor(props) {
        super(props);
        this.inputFile = React.createRef();
        this.state = {
            isMobile: false,
            isSmallMobile: false,
            render: false,
            isSelectAll: false,
            imagesDataList: [],
            UserRole: "",
            DeleteId: 0,
            postdocs: {
                "Id": 0,
                "ShipId": 0,
                "ActionBy": "",
                "ActionDate": moment(new Date()).format('YYYY-MM-DD'),
                "InspectionId": 0,
                "Comments": null,
                "DocumentDate": moment(new Date()).format('YYYY-MM-DD'),
            }
        }
    }

    componentDidMount() {
        const { dispatch } = this.props;
        this.state.UserRole = localStorage.getItem("UserRoles");
        this.state.postdocs.ShipId = localStorage.getItem("DashId");
        this.state.postdocs.ActionBy = localStorage.getItem("UserRoles");
        this.state.postdocs.InspectionId = localStorage.getItem("InspectionId");
        this.setState({});
        this.dataTable();
        window.addEventListener("resize", this.resize.bind(this));
        this.resize();
        this.interval = setInterval(() => {
            this.resize1();
        }, 10);
        let _this = this;
        $(document).on("change", "#checkall", function () {
            if ($(this).is(":checked")) {
                _this.state.isSelectAll = true;
                _this.setState({})
                $(".checkboxes").prop("checked", true).trigger("change");
            } else {
                _this.state.isSelectAll = false;
                _this.setState({})
                $(".checkboxes").prop("checked", false).trigger("change");
            }
        });
        $(document).on("change", ".checkboxes", function () {
            let checkbox = $("input[class='checkboxes']").map(function () {
                return this.value;
            }).length;
            let checked = $("input[class='checkboxes']:checked").map(
                function () {
                    return this.value;
                }
            ).length;
            if (checkbox === checked) {
                _this.state.isSelectAll = true;
                _this.setState({})
                $("#checkall").prop("checked", true);
            } else {
                _this.state.isSelectAll = false;
                _this.setState({})
                $("#checkall").prop("checked", false);
            }
        });

    }

    dataTable = (type) => {
        let Ship = parseInt(localStorage.getItem("DashId"));
        let apiUrl = `${API.GET_ShipImages}?shipId=${Ship}`;
        this.props.dispatch({ type: "SHOW_LOADER", data: true });
        axios.get(apiUrl)
            .then((response) => {
                if (response?.status === 200) {
                    console.log(response.data)
                    this.state.imagesDataList = response?.data;
                    this.state.render = true;
                    this.state.imagesDataList.sort((a, b) => {
                        return a.Id - b.Id;
                    });
                    this.setState({});
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                    if (type === "upload") {
                        successAlert("Uploaded successfully.");
                    }
                    if (type === "delete") {
                        successAlert("Deleted successfully.");
                    }
                    if (type === "comments") {
                    }
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false });
                warningAlert("Something went wrong. Please try again.");
                if (error?.response?.status === 401) {
                }
            });
    }

    UploadFile = (e) => {
        let filename = e?.target?.files[0].name;
        var idxDot = filename.lastIndexOf(".") + 1;
        var extFile = filename.substr(idxDot, filename.length).toLowerCase();
        if (extFile === "pdf") {
            let formData = new FormData()
            Array.from(e.target.files).forEach(async (a) => {
                formData.append("formFiles", a)
            })
            this.Upload_File(this.state.postdocs, formData)
        } else {
            swal("Error!", "Only PDF are allowed.", "warning");
        }
    }

    AttachFiles = (str, ind) => {
        this.inputFile.current.click();
    };

    Upload_File = (data, formData) => {
        let apiUrl = API.POST_ShipImages + '?ActionBy=' + data.ActionBy + '&ActionDate=' + data.ActionDate + '&Id=' + data.Id + '&ShipId=' + data.ShipId + '&InspectionId=' + data.InspectionId + '&Comments=' + data.Comments + '&DocumentDate=' + data.DocumentDate;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "POST",
            url: apiUrl,
            data: formData,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.dataTable("upload");
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                warningAlert("Something went wrong. Please try again.");
                if (error?.response?.status === 401) {
                }
            });
    };
    DownloadFile = (filename, guid) => {
        let apiUrl = API.Download_Document + '?filename=' + filename + '&guidValue=' + guid;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios.get(apiUrl, { responseType: "blob" })
            .then((response) => {
                if (response?.status === 200) {
                    // let fileName = response.headers['content-disposition'].split('filename="')[1].split('";')[0];
                    let blob = new Blob([response.data], { type: response.data.type });
                    let url = URL.createObjectURL(blob);
                    let a = document.createElement('a');
                    a.href = url;
                    a.download = filename;
                    a.click();
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                    successAlert("Downloaded successfully.");
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                warningAlert("Something went wrong. Please try again.");
                if (error?.response?.status === 401) {
                }
            });
    };

    OpenPopup = (Id) => {
        this.state.DeleteId = Id;
        window.$("#deletepopup").modal("show")
    }

    DeleteOthers = () => {
        window.$("#deletepopup").modal("hide")
        this.DeleteOthersApi(this.state.DeleteId, this.state.UserRole)
    }

    DeleteOthersApi = (data, role) => {
        let apiUrl = API.DELETE_ShipImages + '?Ids=' + data + '&actionby=' + role;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "DELETE",
            url: apiUrl,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.dataTable("delete")
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                warningAlert("Something went wrong. Please try again.");
                if (error?.response?.status === 401) {
                }
            });
    };

    componentWillUnmount() {
        clearInterval(this.interval);
        window.removeEventListener("resize", this.resize.bind(this));
        $("#ShipImages1 .MuiListItemText-primary").addClass("spanTopBar")
        $("#ShipImages .MuiListItemText-primary").removeClass("fw-bolder");
        $("#ShipImages").addClass("d-none");
        $("#ShipImages").removeClass("d-block");
        $("#SIL").removeClass("active-color");
        $("#SI").removeClass("fw-bolder");
    }

    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }
        if (window.innerWidth < 310) {
            this.setState({
                isSmallMobile: true
            })
        }
        else {
            this.setState({
                isSmallMobile: false
            })
        }
    };

    resize1 = () => {
        $("#ShipImages1 .MuiListItemText-primary").addClass("spanTopBar")
        $("#ShipImages .MuiListItemText-primary").addClass("fw-bolder");
        $("#ShipImages").removeClass("d-none");
        $("#ShipImages").addClass("d-block");
        $("#SIL .MuiListItemText-primary").addClass("fw-bolder");
        $("#SI").addClass("active-color");
    };

    handleInputChange = (e, val) => {
        this.state.imagesDataList.map((i) => (
            i.Id == val.Id ? i.Comments = e.target.value : ""
        ))
        this.setState({})
    }

    updatecomments = (e, val) => {
        let data = {
            "DocumentId": val.Id,
            "Comments": val.Comments.trim(),
            "Status": "Completed",
            "ActionBy": this.state.UserRole,
            "DocumentDate": val.DocumentDate
        }
        this.put_comments(data)
    }

    put_comments = (data) => {
        let apiUrl = API.Update_ShipImages;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "PUT",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.dataTable("comments");
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                warningAlert("Something went wrong. Please try again.");
                if (error?.response?.status === 401) {
                }
            });
    };

    AddCancel1 = () => {
        this.props.navigate(`/shiplist`)
    }
    DownloadAttachFiles = () => {
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        let Ship = parseInt(localStorage.getItem("DashId"));
        let ShipName = localStorage.getItem("ShipName");
        var ids = $("input[class='checkboxes']:checked").map(function () {
            return this.value;
        }).get().join(", ");
        if (ids !== "") {
            var idsArray = ids.replace(/, +/g, ",").split(",").map(Number);
        } else {
            var idsArray = []
        }
        let apiUrl = API.Download_Zip_Files;
        let data = {
            shipId: Ship,
            isDocuments: false,
            isAllFiles: this.state.isSelectAll,
            file_Ids: idsArray,
        }
        axios({
            method: "POST",
            url: apiUrl,
            data: data,
            responseType: "blob",
        })
            .then((response) => {
                if (response?.status === 200) {
                    let fileName = "Photographs_" + ShipName + moment().format("DD MM YYYY LT") + ".zip"
                    let blob = "";
                    blob = new Blob([response.data], { type: response.data.type });
                    FileSaver.saveAs(blob, fileName);
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                    successAlert("Downloaded successfully.");
                }
            })
            .catch((error) => {
                $(".checkboxes").each(function () {
                    if ($(this).is(":checked")) {
                        this.state.isSelectAll = false;
                        this.setState({})
                        $(this).prop("checked", false);
                    }
                });
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                warningAlert("Something went wrong. Please try again.");
            });
    }

    render() {
        let { classes, menuToggle } = this.props;
        return (
            <>
                {this.state.isMobile ?
                    <>
                        <div className="row w-100 mt-4 mob-topfixed ">
                            <div className="col-6 w-50 mt-auto">
                                <List className="pt-4 mt-4" style={{ backgroundColor: "#F6F6F6" }}>
                                    <ListItem className={`${this.state.isSmallMobile ? "photograph-padding" : ""}`}>
                                        <ListItemText id={"ShipImages" + "1"} className='textNaviIcon' primary="Photographs" />
                                        <NavigateNextIcon id="ShipImages" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                                        <Divider className='border-bottom' />
                                    </ListItem>
                                </List>
                            </div>
                            <div className="col-6 pt-3 mt-5 w-50">
                                <h4> Photographs </h4>
                            </div>
                        </div>
                    </>
                    :
                    <></>
                }
                <div className={`mt-130 ${this.state.isMobile ? this.state.UserRole === "Client" || this.state.UserRole === "External Client" ? "ml-auto scroll-hide border-top" : "ml-auto scroll-hide" : "ml-auto scroll-hide"}`} style={{ backgroundColor: "#FFFFFF", width: this.state.isMobile ? "100%" : menuToggle ? localStorage.getItem("UserRoles").toLowerCase() == "client" ? "calc(100% - 300px)" : "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '' : -75 }}>
                    {this.state.isMobile ?
                        <table className="dataTable border-top" width="100%">
                            <tbody>
                                <tr className="">
                                    <td width="5%" className="border-right text-center">
                                        <i
                                            class="fa fa-arrow-left cursorPointer"
                                            onClick={this.AddCancel1}
                                        ></i>
                                    </td>
                                    <td width="47%">
                                        {this.state.UserRole === "Client" || this.state.UserRole === "External Client" ? <></> : <>
                                            <img src={upload} className="pl-2" onChange={(e) => this.UploadFile(e)} onClick={() => { this.AttachFiles(0) }} style={{ width: "18px", height: "18px", marginTop: '-4px' }} />
                                            <span className="p-2 cursorPointer" onChange={(e) => this.UploadFile(e)} onClick={() => { this.AttachFiles(0) }}>Upload Photographs</span>
                                            <input
                                                type="file"
                                                hidden
                                                multiple
                                                accept=".pdf"
                                                onChange={(e) => this.UploadFile(e)}
                                                ref={this.inputFile}
                                            /> </>}
                                    </td>
                                    <td width="47%">
                                        <img className="" src={localStorage.getItem("UserRoles").toLowerCase() === "client" ? downloadiconblue : downloadIcon} style={{ marginTop: '-4px' }}></img>
                                        <span className="pl-2 cursorPointer" onClick={() => this.DownloadAttachFiles()}>Download All</span>

                                    </td>
                                </tr>
                            </tbody>
                        </table> :
                        <>
                            <table className="dataTable" width="100%">
                                <tbody>
                                    <tr className="">
                                        <td width="5%" className="border-right text-center">
                                            <i class="fa fa-arrow-left cursorPointer"
                                                onClick={this.AddCancel1}
                                            ></i>
                                        </td>
                                        <td width="95%" className=""><>
                                            {this.state.UserRole === "Client" || this.state.UserRole === "External Client" ? <></> : <>
                                                <img src={upload} className="pl-2" onChange={(e) => this.UploadFile(e)} onClick={() => { this.AttachFiles(0) }} style={{ width: "18px", height: "18px", marginTop: '-4px' }} />
                                                <span className="p-2 cursorPointer" onChange={(e) => this.UploadFile(e)} onClick={() => { this.AttachFiles(0) }}>Upload Photographs</span>
                                                <input
                                                    type="file"
                                                    hidden
                                                    multiple
                                                    accept=".pdf"
                                                    onChange={(e) => this.UploadFile(e)}
                                                    ref={this.inputFile}
                                                /> </>}
                                            <img className="pl-3" src={localStorage.getItem("UserRoles").toLowerCase() === "client" ? downloadiconblue : downloadIcon} style={{ width: "18px", height: "18px", marginTop: '-4px' }}></img>
                                            <span className="p-2 cursorPointer" onClick={() => this.DownloadAttachFiles()}>Download All</span>
                                        </>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </>}
                    <div className="row px-4 py-3">
                        <div className="col-12 pb-2">
                            {this.state.isMobile ? <></> : <h6>Photographs</h6>}
                        </div>
                        <div className="col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12">
                            <div className="table-responsive" style={{ width: "100%" }}>
                                <table id="Docstable" className="table table-borderless border-top border-bottom border-left border-right">
                                    <thead>
                                        <tr className="table-active">
                                            <th className="border-top border-right border-left" width="3%"><span className="fw-bold" style={{ color: "#000000" }}>
                                                <input type="checkbox" id="checkall" style={{ width: "16px", height: "16px" }} /></span></th>
                                            <th width="3%" className="border-right"><span className="spandoc-thead">S.No</span></th>
                                            <th className={`${window.innerWidth < 1080 ? "docwidthmobile-td" : "docwidth-td"} border-right align-middle`}><span className="spandoc-thead">Photograph</span></th>
                                            <th className="spandate-thead border-right text-center align-middle"><span className="spandoc-thead Nowrap">Created On</span></th>
                                            <th className={`${window.innerWidth < 1080 ? "commentsmobile-td" : "comments-td"} align-middle`}><span className="spandoc-thead">Comments</span></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.render == true ? <>
                                            {this.state.imagesDataList && this.state.imagesDataList?.map((i, ind) => (<>
                                                <tr className="border-top">
                                                    <td className="align-middle border-right border-left">
                                                        <input type="checkbox" className="checkboxes" style={{ width: "16px", height: "16px" }} value={i.Id} />
                                                    </td>
                                                    <td className="border-right text-center align-middle"><span className="spandoc-td">{ind + 1}</span></td>
                                                    <td className={`${window.innerWidth < 1080 ? "docwidthmobile-td" : "docwidth-td"} border-right align-middle`}>
                                                        <div className="col-12 m-0 p-0 row">
                                                            <div className="col-6 col-lg-6 col-md-6 col-sm-6 col-xl-6 overflow pl-0">
                                                                <span className="spandoc-td">{i.Name && i.Name}</span>
                                                            </div>
                                                            <div className="col-6 col-lg-6 col-md-6 col-sm-6 col-xl-6 p-0 space-doc">
                                                                {i.Attachment.FileUrl && i.Attachment.FileUrl != "" ? <>
                                                                    <a href={i.Attachment.FileUrl} target="_blank" className="link-colors pl-2">
                                                                        <img src={localStorage.getItem("UserRoles").toLowerCase() === "client" ? Viewblue : View} className="cursorPointer pl-1 viewdel-td" />
                                                                        <span className="pl-1 cursorPointer link-color">View</span></a>
                                                                    <img className="pl-2 cursorPointer" src={localStorage.getItem("UserRoles").toLowerCase() === "client" ? downloadiconblue : downloadIcon} style={{ marginTop: '-4px' }} onClick={() => this.DownloadFile(i.Attachment.FileName, i.Attachment.AwsUniqueFileName)}></img>
                                                                    <span className="pl-1 cursorPointer" onClick={() => this.DownloadFile(i.Attachment.FileName, i.Attachment.AwsUniqueFileName)}>Download</span>
                                                                    {this.state.UserRole === "Client" || this.state.UserRole === "External Client" ? <></> : <>
                                                                        <img src={Delete} className="pl-2 cursorPointer viewdel-td" onClick={() => { this.OpenPopup(i.Id) }} />
                                                                        <span className="pl-1 cursorPointer" onClick={() => { this.OpenPopup(i.Id) }}>Delete</span> </>}</> : <>
                                                                </>}
                                                            </div>
                                                        </div></td>
                                                    <td className="spandate-thead border-right text-center align-middle">{i.ImageDate && moment(i.ImageDate).format("DD/MM/YYYY")}</td>
                                                    <td className={`${window.innerWidth < 1080 ? "commentsmobile-td" : "comments-td"} align-middle`}>
                                                        {this.state.UserRole && this.state.UserRole === "Client" || this.state.UserRole === "External Client" ?
                                                            <CssTextField
                                                                multiline
                                                                fullWidth
                                                                disabled
                                                                variant="outlined"
                                                                type="text"
                                                                value={i.Comments != "null" ? i.Comments : ""}
                                                                InputProps={{
                                                                    className: `border-radius padding-space ${classes.inputfieldAlign}`
                                                                }}
                                                            /> :
                                                            <CssTextField
                                                                multiline
                                                                fullWidth
                                                                variant="outlined"
                                                                type="text"
                                                                onChange={(e) => this.handleInputChange(e, i)}
                                                                onBlur={(e) => this.updatecomments(e, i)}
                                                                value={i.Comments != "null" ? i.Comments : ""}
                                                                InputProps={{
                                                                    className: `border-radius padding-space ${classes.inputfieldAlign}`
                                                                }}
                                                            />
                                                        }
                                                    </td>
                                                </tr>
                                            </>))}
                                        </> : <></>}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade p-5 mt-5" id="deletepopup" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">Are you sure you want to delete?</h5> </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#499AC8", border: "none" }} onClick={() => this.DeleteOthers()}><span className="" >Delete</span></button>
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} id="closemodal1" onClick={() => { window.$("#deletepopup").modal("hide") }} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >Cancel</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
    };
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(shipImage))
);
